<script>
	import Smiley from './Smiley.svelte'
	import {spring} from 'svelte/motion';
	import { createEventDispatcher } from 'svelte';
	import { onMount } from 'svelte';

	const dispatch = createEventDispatcher();

	//set a prop for customer sat level
	export let value = 50;
	export let bgOn = false;
	export let valuesOn = false;
	export let lowLabel = "Frustration";
	export let highLabel= "Delight";
	export let key = 0;

	let isMouseDown = false;
	let smileyscale = spring(1);
	let m = { x: 0, y: 0 };
	let h;
	
	$: ratio = (h/100);

	function dispatchMessage(value) {
		dispatch('message', {
			cs: value,
		});
	}

	function handleMousemove(e){
		if (isMouseDown){
		var rect = e.target.getBoundingClientRect();
		if(e.type==='touchmove'){
			var y = e.touches[0].clientY - rect.top;  //y position within the element.
				if(y > -5 && y < h){
					//this is based around a height of 200px need to make this adjust to any element height.
					m.y = Math.round((h/ratio)-(y/ratio))
				}
			e.preventDefault();
		}else{
			var y = e.clientY - rect.top;  //y position within the element.
			m.y = Math.round((h/ratio)-(y/ratio))
		}
			value = m.y
			dispatchMessage(value);
		}
	}

	function getBgColor(range){
		let bg = 'rgba(0,255,0,.2)'
		switch(true){

			case (range >= 0 && range < 20 ): bg='rgba(255,0,0,.3)';break;
			case (range >= 20 && range < 30 ): bg='rgba(255,85,0,.3)';break;
			case (range >= 30 && range < 50 ): bg='rgba(255,170,0,.3)';break;
			case (range >= 50 && range < 60 ): bg='rgba(255,255,0,.3)';break;
			case (range >= 60 && range < 70 ): bg='rgba(170,255,0,.3)';break;
			case (range >= 70 && range < 80 ): bg='rgba(85,255,0,.3)';break;
			case (range >= 80 && range < 100 ): bg='rgba(0,255,0,.3)';break;
		}
		return bg;
	}

</script>
<style>
	.wrapper{		
		position:relative;		
		min-width: 150px;
		min-height: 225px;
	}
	.inner{
		display: block;
		transition: background 1s;
		position: absolute;
		top: 30px;
		bottom: 30px;
		left: 0;
		right:0;
		padding:0;
		overflow: visible;
		@apply border-t border-b border-gray-100; 
	}

	.inner .bar{
		transition: background .3s;
		background: rgba(0,178,255, .1);
		width:100%;
		height:100%;
		position: absolute;
		bottom:0;		
	}
	.value{
		font-size: .7em;
		color: rgba(0,0,0,1);
		position: absolute;
		bottom: 10px;
		right: 10px;
		background: #fff;
		padding: 4px;
		border-radius:50%;
		font-weight: bold;
	}

	.wrapper:first-child .key{
		display: block;

	}

	.inner:before{
			position: absolute;
			left: 0;
			top: 50%;
			height: 0px;
			border-bottom: 1px dashed rgba(255,0,0,.5);
			background: transparent;
			content: "";
			width: 100%;
			display: block;
	}
	.smiley{
		position:absolute;
 		left: calc(50% - 20px);
		height:40px;
		padding:0;
		margin:0;
	}

	.key, .key-lowLabel{
		text-transform:uppercase;
		letter-spacing:.2em;
		color: rgba(0,0,0,.8);
		font-size:.5em;
		position: absolute;
		bottom:10px;
		left:10px;

	}
	.key-highLabel{
		top:10px;		
	}
	.hotspot{
		position: absolute;
		width:50px;
		margin:auto;
		height:100%;
		top:0;
		bottom:0;
		right:0;
		left:0;
		cursor: pointer;
	}
</style>

<div class="wrapper border-r" >
{#if (key=="1")}
	<span class="key key-highLabel">{highLabel} ↑</span>
	<span class="key key-lowLabel">{lowLabel} ↓</span>
{/if}
	<div class="inner" style="background:{bgOn ? getBgColor(value):'transparent'}">
	<div class="bar" style="height:{value}%;background:{bgOn ? getBgColor(value): 'rgba(0,204,255, .1)'})">
		</div>
		<div
			id="smiley-button-{key}"
			class="smiley"
			style="bottom:{(value*ratio)-(20)}px;"
			>
			<Smiley bind:smile={value} size="40" scale={$smileyscale}  />
		</div>
		<div class="hotspot" bind:clientHeight={h}
		on:mousemove="{handleMousemove}"
		on:touchmove="{handleMousemove}"
		on:mouseenter="{()=>smileyscale.set(1.5)}"
		on:mouseleave="{()=>{isMouseDown=false;smileyscale.set(1.1)}}"
		on:mousedown="{()=> {isMouseDown=true;smileyscale.set(2)}}"
		on:mouseup="{()=>{isMouseDown=false;smileyscale.set(1.5)}}"
		on:touchstart="{()=> {isMouseDown=true;smileyscale.set(2)}}"
		on:touchend="{()=>{isMouseDown=false;smileyscale.set(1)}}"
		/>
		{#if valuesOn}
		<div class="value" style="width:15px;height:10px;text-align:center;line-height:10px;background:{getBgColor(value)}">
			{Math.round(value/10)}
			{ratio}
		</div>
		{/if}
	</div>
</div>
